import { useEffect, useState } from "react"
import ArrowBackButton from "../../../../components/button/ArrowBackButton"
import { useParams } from "react-router-dom"
import usePhaseForm from "./usePhaseForm"
import ActionButtonGradient from "../../../../components/button/ActionButtonGradient"

const PhaseForm = () => {
    const params = useParams()
    const [isUpdate, setUpdate] = useState(false)

    const {
        payload,
        onChangeHandler,
        postPhaseForm,
        putPhaseForm,
        isSaving,
        getPhaseForm
    } = usePhaseForm()

    useEffect(() => {
        if (params.phase_id) {
            setUpdate(true)
            getPhaseForm(params.phase_id)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params.phase_id])

    return(
        <div className="container-fluid justify-content-center" style={{ 
            maxWidth: '1200px', 
            margin: '0 auto',
            width: '100%',
        }}>
            <div style={{ marginBottom: '24px' }}>
                <ArrowBackButton 
                    title={isUpdate ? "Edit Phase" : "Create Phase"} 
                    isTwoSection={true}
                />
            </div>
            
            <div style={{
                backgroundColor: '#ffffff',
                borderRadius: '12px',
                padding: '24px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                border: '1px solid #f0f0f0'
            }}>
                <h5 style={{ 
                    margin: 0,
                    marginBottom: '24px',
                    fontWeight: 600,
                    color: '#1a1a1a',
                    fontSize: '18px'
                }}>
                    {isUpdate ? "Edit Phase" : "Phase Information"}
                </h5>

                <form onSubmit={ 
                    isUpdate? 
                    (e) => putPhaseForm(e):
                    (e) => postPhaseForm(e)
                }>
                    <div style={{
                        padding: '20px',
                        backgroundColor: '#f8f9fa',
                        borderRadius: '8px',
                        border: '1px solid #e5e7eb',
                        marginBottom: '24px'
                    }}>
                        <div className="mb-4">
                            <label htmlFor="Name" style={{ 
                                fontWeight: '600', 
                                color: '#374151', 
                                fontSize: '14px',
                                marginBottom: '8px',
                                display: 'block'
                            }}>
                                Phase <span style={{color: 'red'}}>*</span>
                            </label>
                            <input 
                                required
                                type="text" 
                                name="Name"
                                className="form-control" 
                                id="Name" 
                                placeholder="Enter Phase Name"
                                value={payload.Name}
                                onChange={onChangeHandler}
                                style={{
                                    padding: '8px 12px',
                                    borderRadius: '6px',
                                    border: '1px solid #d1d5db',
                                    fontSize: '16px'
                                }}
                            />
                        </div>

                        <div className="mb-0">
                            <label htmlFor="Order" style={{ 
                                fontWeight: '600', 
                                color: '#374151', 
                                fontSize: '14px',
                                marginBottom: '8px',
                                display: 'block'
                            }}>
                                Order <span style={{color: 'red'}}>*</span>
                            </label>
                            <input 
                                required
                                type="number" 
                                name="Order"
                                className="form-control" 
                                id="Order" 
                                placeholder="Enter Phase Order (e.g., 1, 2, 3)"
                                value={payload.Order}
                                onChange={onChangeHandler}
                                style={{
                                    padding: '8px 12px',
                                    borderRadius: '6px',
                                    border: '1px solid #d1d5db',
                                    fontSize: '16px'
                                }}
                            />
                            <small style={{ color: '#6c757d', fontSize: '13px', marginTop: '4px', display: 'block' }}>
                                Lower numbers will appear first in the phase sequence
                            </small>
                        </div>
                    </div>

                    <div className="d-flex justify-content-end">
                        { isUpdate ? 
                            <ActionButtonGradient
                                type="submit"
                                variant="primary"
                                disabled={isSaving}
                                children={isSaving ? "Saving..." : "Save Changes"}
                            /> :
                            <ActionButtonGradient
                                type="submit"
                                variant="success"
                                disabled={isSaving}
                                children={isSaving ? "Saving..." : "Save Phase"}
                            />
                        }
                    </div>
                </form>
            </div>
        </div>
    )
}

export default PhaseForm